module.exports = __webpack_public_path__ + "static/media/campaign_monitor_logo.5568a0b3.svg";